const TransactionReducer = (state, action) => {
    switch (action.type) {

        case "GET_TRANSACTIONS_START":
            return {
                ...state,
                isFetching: true,
                error: false,
            };

        case "GET_TRANSACTIONS_SUCCESS":
            return {
                ...state,
                transactions: action.payload,
                isFetching: false,
                error: false,
                hasFetched: true,
            };

        case "GET_TRANSACTIONS_FAILURE":
            return {
                ...state,
                isFetching: false,
                error: true,
                hasFetched: false,
            };

        default:
            return state;
    }
};

export default TransactionReducer;